import React from 'react';
import PropTypes from 'prop-types';
import Icons from './Icons';
import TranslatedLink from '../../../../modules/wizard/common/components/TranslatedLink';

const Settings = (props) => {
  const {
    loggedIn,
  } = props;

  return (
    <TranslatedLink to="admin" className="setting-div" target="_blank">
      <Icons.Setting className={`admin-icon-${loggedIn}`} />
    </TranslatedLink>
  );
};

Settings.propTypes = {
  loggedIn: PropTypes.bool,
};

export default Settings;
